import { __ } from '@wordpress/i18n';
import { PanelBody, SelectControl } from '@wordpress/components';

// Translated at module load; WP loads i18n catalog before block scripts.
const POSITION_OPTIONS = [
  { label: __('Below image', 'brandy-blocks'), value: 'below' },
  { label: __('Top left', 'brandy-blocks'), value: 'top-left' },
  { label: __('Top right', 'brandy-blocks'), value: 'top-right' },
  { label: __('Bottom left', 'brandy-blocks'), value: 'bottom-left' },
  { label: __('Bottom right', 'brandy-blocks'), value: 'bottom-right' },
  { label: __('Center', 'brandy-blocks'), value: 'center' },
  { label: __('Hidden', 'brandy-blocks'), value: 'hidden' },
];

export default function TitlePositionPanel({ attributes, setAttributes }) {
  const { titlePosition } = attributes;
  return (
    <PanelBody title={__('Title position', 'brandy-blocks')} initialOpen={false}>
      <SelectControl
        label={__('Position', 'brandy-blocks')}
        help={__('Applied to all items in this grid.', 'brandy-blocks')}
        value={titlePosition}
        options={POSITION_OPTIONS}
        onChange={(value) => setAttributes({ titlePosition: value })}
      />
    </PanelBody>
  );
}
